<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Update Project</p>
      <b-button type="is-danger" icon-left="delete" @click="deleteProject"
        >Delete Project</b-button
      >
    </header>
    <section class="modal-card-body">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <item-title
          :title="project.title"
          :itemType="'project'"
          :displaySuccess="false"
          @updateTitle="localProject.title = $event"
        />

        <project-character
          :character="project.character"
          :version="project.version"
          :universe="project.universe"
          @updateCharacter="localProject.character = $event"
          @updateVersion="localProject.version = $event"
          @updateUniverse="localProject.universe = $event"
        />

        <item-description
          :description="project.description"
          @updateDescription="localProject.description = $event"
        />

        <!-- TODO CHANGE ITEM PROGRESS TO THE ONE IN COMMENT  -->
        <!-- <item-progress
          :progress="project.progress"
          :itemType="'project'"
          @updateProgress="localProject.progress = $event"
        /> -->
        <item-progress :progress="1" :itemType="'project'" />

        <item-tags
          :tags="project.tag_list"
          :placeholder="'WCS, Comic Con, Photoshop...'"
          @updateTags="localProject.tag_list = $event"
        />

        <item-visibility
          :hidden="project.hidden"
          :itemType="'project'"
          @updateHidden="localProject.hidden = $event"
        />
      </ValidationObserver>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>

      <span class="card-footer-item">
        <b-button type="is-success" @click="updateProject">Update</b-button>
      </span>
    </footer>
  </div>
</template>

<script>
// Components
import { ValidationObserver } from 'vee-validate'
import { mapGetters } from 'vuex'

// Attributes
import ItemTitle from '@/components/Attributes/ItemTitle'
import ProjectCharacter from '@/components/Attributes/ProjectCharacter'
import ItemDescription from '@/components/Attributes/ItemDescription'
import ItemProgress from '@/components/Attributes/ItemProgress'
import ItemTags from '@/components/Attributes/ItemTags'
import ItemVisibility from '@/components/Attributes/ItemVisibility'

// Mixins
import { notificationMixin } from '@/mixins/notificationMixin'

export default {
  mixins: [notificationMixin],
  components: {
    ValidationObserver,
    ItemTitle,
    ProjectCharacter,
    ItemDescription,
    ItemProgress,
    ItemTags,
    ItemVisibility
  },
  props: ['project'],
  data () {
    return {
      localProject: {
        title: null,
        character: null,
        universe: null,
        version: null,
        description: null,
        tag_list: [],
        hidden: false
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  created () {
    this.localProject = {
      title: this.project.title,
      character: this.project.character,
      universe: this.project.universe,
      version: this.project.version,
      description: this.project.description,
      tag_list: this.project.tag_list,
      hidden: this.project.hidden
    }
  },
  methods: {
    updateProject () {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.$store
            .dispatch('projects/update', { id: this.project.id, data: this.localProject })
            .then((resp) => {
              this.$parent.close()
              this.$emit('updated', resp.data.data.attributes)
            })
            .catch((error) => {
              console.log(error.response)
              this.alertError()
            })
        }
      })
    },
    deleteProject () {
      this.$buefy.dialog.confirm({
        title: 'Deleting Project',
        message:
          'Are you sure you want to <b>delete</b> your Project and all the Crafts & Purchases linked to it? This action cannot be undone.',
        confirmText: 'Delete Project',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store
            .dispatch('projects/destroy', this.project.id)
            .then((resp) => {
              this.$router.push(`/users/${this.currentUser.attributes.username}`)
              this.$buefy.toast.open('Project has been deleted')
            })
            .catch((err) => {
              console.log(err)
              this.$buefy.toast.open('Project could not be deleted')
            })
        }
      })
    }
  }
}
</script>
